import type { PrecisionValue } from '../../../../analyticsModule/components/tools/AnalyticsPrecisionSelect/AnalyticsPrecisionSelect.types'

export const precisionOptions: PrecisionValue[] = [
  {
    label: 'Hour',
    value: 'hour',
  },
  {
    label: 'Day',
    value: 'day',
  },
  {
    label: 'Week',
    value: 'week',
  },
  {
    label: 'Month',
    value: 'month',
  },
  {
    label: 'Quarter',
    value: 'quarter',
  },
  {
    label: 'Year',
    value: 'year',
  },
]
